import firebase from 'firebase';
import apiKeys from '../constants/apiKeys';
import ReduxSagaFirebase from 'redux-saga-firebase';

const myFirebaseApp = firebase.initializeApp(apiKeys.FirebaseConfig);
const reduxSagaFirebase = new ReduxSagaFirebase(myFirebaseApp);

export default reduxSagaFirebase;